<!-- Team Rank-->
<template>
  <div class="tr-list-page">
    <!-- 전체 레이아웃 그리드 -->
    <div class="main-grid-layout">
      <!-- 1. 연도별 매출 그리드 -->
      <div class="sales-grid">
        <div v-if="isSaveButtonVisible" class="button-row">
          <button v-if="isSaveButtonVisible" class="btn-save-grid" @click="saveTotalMonthlyCount">저장</button>
          <button
            v-if="isSaveButtonVisible"
            class="btn-save-grid"
            @click="totalMonthlyCountCopy"
          >
            복사
          </button>
        </div>
        <ag-grid-vue
          class="ag-tr-balham top-grid total-monthly-grid-ag"
          :columnDefs="totalMonthlyCountColumnDefs"
          :rowData="totalMonthlyCountData"
          :gridOptions="totalMonthlyCountGridOptions"
          @grid-ready="onTotalMonthlyCountGridReady"
          :theme="theme"
          style="width: 100%; height: 100%"
        />
      </div>

      <!-- 5. 오른쪽 본부 별 그리드 -->
      <div class="monthly-stats-grid">
        <div v-if="isSaveButtonVisible" class="button-row">
          <button v-if="isSaveButtonVisible" class="btn-save-grid" @click="saveAvgCount">저장</button>
          <button
            v-if="isSaveButtonVisible"
            class="btn-save-grid"
            @click="avgCountCopy"
          >
            복사
          </button>
        </div>
        <ag-grid-vue
          class="ag-tr-balham top-grid avg-stats-grid-ag"
          :columnDefs="avgCountColumnDefs"
          :rowData="avgCountData"
          :gridOptions="avgCountGridOptions"
          @grid-ready="onAvgCountGridReady"
          :theme="theme"
          style="width: 100%; height: 100%"
        />
        <!-- :pinnedTopRowData="pinnedTopRowData" -->
      </div>

      <!-- 2,3,4 영역 컨테이너 -->
      <div class="middle-container">
        <!-- 2. 달력 그리드 -->
        <div class="group-grid">
          <div v-if="isSaveButtonVisible" class="button-row">
            <button class="btn-save-grid" @click="saveDailyLastSalesCount">저장</button>
            <button
              class="btn-save-grid"
              @click="dailyLastSalesCountCopy"
            >
              복사
            </button>
          </div>
          <ag-grid-vue
            class="ag-tr-balham middle-grid last-sales-calendar-ag"
            :columnDefs="dailyLastSalesCountColumnDefs"
            :rowData="dailyLastSalesCountData"
            :gridOptions="dailyLastSalesCountGridOptions"
            @grid-ready="onDailyLastSalesCountGridReady"
            :theme="theme"
            style="width: 100%; height: 100%"
          />
        </div>

        <!-- 3. 달력 그리드 -->
        <div class="right-stats-grid">
          <div v-if="isSaveButtonVisible" class="button-row">
            <button class="btn-save-grid" @click="saveDailySales">저장</button>
            <button
              class="btn-save-grid"
              @click="dailySalesCountCopy"
            >
              복사
            </button>
          </div>
          <ag-grid-vue
            class="ag-tr-balham middle-grid sales-calendar-ag"
            :columnDefs="dailySalesCountColumnDefs"
            :rowData="dailySalesCountData"
            :gridOptions="dailySalesCountGridOptions"
            @grid-ready="onDailySalesCountGridReady"
            :theme="theme"
            style="width: 100%; height: 100%"
          />
        </div>

        <!-- 4. 통계 테이블 -->
        <div class="stats-table">
          <button v-if="isSaveButtonVisible" class="btn-save-grid" @click="saveStatsTable">저장</button>
          <table>
            <tbody>
              <tr>
                <th>월계</th>
                <td contenteditable="true" style="direction: rtl;" @input="e => totalSaleData[0].MonthTotal = e.target.innerText">
                  {{ formatNumber(totalSaleData[0]?.MonthTotal) }}
                </td>
              </tr>
              <tr>
                <th>월예상</th>
                <td contenteditable="true" style="direction: ltr;" @input="e => totalSaleData[0].MonthEst = e.target.innerText.replace(/\D/g, '')">
                  {{ formatNumber(totalSaleData[0]?.MonthEst) }}
                </td>
              </tr>
              <tr>
                <th>연누계</th>
                <td contenteditable="true" style="direction: ltr;" @input="e => totalSaleData[0].YearTotal = e.target.innerText.replace(/\D/g, '')">
                  {{ formatNumber(totalSaleData[0]?.YearTotal) }}
                </td>
              </tr>
              <tr>
                <th>연예상</th>
                <td contenteditable="true" style="direction: ltr;" @input="e => totalSaleData[0].YearEst = e.target.innerText.replace(/\D/g, '')">
                  {{ formatNumber(totalSaleData[0]?.YearEst) }}
                </td>
              </tr>
              <tr>
                <th>일평균</th>
                <td contenteditable="true" style="direction: ltr;" @input="e => totalSaleData[0].DailyAvg = e.target.innerText.replace(/\D/g, '')">
                  {{ formatNumber(totalSaleData[0]?.DailyAvg) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 7. 하단 그리드 -->
      <div class="bottom-grid">
        <div v-if="isSaveButtonVisible" class="button-row">
          <button class="btn-save-grid" @click="saveStoreCount">저장</button>
          <button
            class="btn-save-grid"
            @click="storeCountCopy"
          >
            복사
          </button>
        </div>
        <ag-grid-vue
          class="ag-tr-balham store-count-grid-ag"
          :columnDefs="storeCountColumnDefs"
          :rowData="storeCountData"
          :gridOptions="storeCountGridOptions"
          :theme="theme"
          @grid-ready="onGridReady"
          style="width: 100%; height: 100%"
          @cell-double-clicked="onStoreCountDoubleClicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "GtListPage",
  components: { AgGridVue },
  data() {
    return {
      selectedBranch: "", // 선택된 본부
      branchList: [],

      quickFilterText: "",

      gridApi: null,
      totalMonthlyCountGridApi: null,
      avgCountGridApi: null,
      dailyLastSalesCountGridApi: null,
      dailySalesCountGridApi: null,

      showPopup: false,
      popupShopCd: "",
      popupShopNm: "",

      isLoading: false, // 로딩 상태

      userInfo: null, // 로그인한 사용자 정보

      // selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        rowHeight: 16,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      totalMonthlyCountData: [],
      totalMonthlyCountColumnDefs: [
        {
          headerName: "",
          field: "TITLE",
          cellStyle: { backgroundColor: "#a6ef63", justifyContent: "center" },
          flex: 1.12,
        },
        ...[...Array(12).keys()].map((i) => ({
          headerName: `${i + 1}월`,
          field: `M${i + 1}`,
          flex: 1.2,
          valueFormatter: (params) => this.formatNumber(params.value),
          cellStyle: (params) => {
            let style = {};
            style.justifyContent = "right";
            const monthKey = `M${i + 1}`;
            const isMaxValue =
              Number(params.value) ===
              Number(params.data.maxValues?.[monthKey]);
            if (params.data.TITLE !== "차이" && isMaxValue) {
              style.color = "red";
            }
            if (params.data.TITLE === "차이") {
              if (params.value < 0) {
                style.color = "blue";
              } else {
                style.color = "red";
              }
            }
            return style;
          },
        })),
        {
          headerName: "합계",
          field: "MSUM",
          flex: 1.32,
          valueFormatter: (params) => this.formatNumber(params.value),
          cellStyle: { backgroundColor: "#fedafb", justifyContent: "right" },
        },
      ],
      totalMonthlyCountGridOptions: {
        headerHeight: 22,
        rowHeight: 20,
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: false,
          resizable: true,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a6ef63",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      dailySalesCountData: [],
      // dailySalesCountColumnDefs: [],
      dailySalesCountGridOptions: {
        headerHeight: 24,
        rowHeight: 22,
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: false,
          resizable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#c0ffc0",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      dailyLastSalesCountData: [],
      // dailyLastSalesCountColumnDefs: [],
      dailyLastSalesCountGridOptions: {
        headerHeight: 24,
        rowHeight: 22,
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: false,
          resizable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a0caf3",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      totalSaleData: [],

      avgCountData: [],
      avgCountColumnDefs: [
        {
          headerName: "NO",
          field: "RowNo",
          valueGetter: "node.rowIndex + 1",
          cellStyle: this.avgCountCellStyle,
          cellDataType: 'number',
          width: 18,
          pinned: "left",
        },
        {
          headerName: "평균점수",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "본부",
              field: "ASBN",
              flex: 1,
              cellStyle: this.avgCountCellStyle,
            },
            {
              headerName: "점수",
              field: "ASScore",
              flex: 1,
              cellDataType: 'number',
              cellStyle: this.avgCountCellStyle,
            },
          ],
        },
        {
          headerName: "평균수량",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "본부",
              field: "AQBN",
              flex: 1,
              cellStyle: this.avgCountCellStyle,
            },
            {
              headerName: "점평",
              field: "AQScore",
              flex: 1,
              cellDataType: 'number',
              cellStyle: this.avgCountCellStyle,
            },
          ],
        },
        {
          headerName: "대당판매비율",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "본부",
              field: "SRDBN",
              flex: 1,
              cellStyle: this.avgCountCellStyle,
            },
            {
              headerName: "당일",
              field: "SRDScore",
              flex: 1,
              cellDataType: 'number',
              cellStyle: this.avgCountCellStyle,
            },
            {
              headerName: "본부",
              field: "SRABN",
              flex: 1,
              cellStyle: this.avgCountCellStyle,
            },
            {
              headerName: "누적",
              field: "SRAScore",
              flex: 1,
              cellDataType: 'number',
              cellStyle: this.avgCountCellStyle,
            },
          ],
        },
      ],
      avgCountGridOptions: {
        headerHeight: 24,
        rowHeight: 22,
        suppressHorizontalScroll: false,
        tooltipShowMode: "whenTruncated",
        enableBrowserTooltips: false,
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: false,
          resizable: false,
          tooltipValueGetter: (params) => params.value,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a0caf3",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      storeCountData: [],
      storeCountColumnDefs: [
        {
          headerName: "매장정보",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "No.",
              valueGetter: "node.rowPinned === 'top' ? '' : node.rowIndex + 1",
              width: 25,
              flex: 0.6,
              pinned: "left",
              cellStyle: {
                justifyContent: "center",
                backgroundColor: "#a0caf3",
              },
            },
            {
              headerName: "점번",
              field: "SC1",
              width: 35,
              flex: 1,
              pinned: "left",
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "점포명",
              field: "SC2",
              width: 80,
              flex: 1,
              pinned: "left",
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "사업주명",
              field: "SC3",
              width: 60,
              flex: 1,
              pinned: "left",
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "나이",
              width: 30,
              field: "SC4",
              flex: 1,
              pinned: "left",
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "경력",
              field: "SC5",
              width: 30,
              flex: 1,
              pinned: "left",
              // cellStyle: { textAlign: "right", backgroundColor: "#ffffbb" },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#ffffbb",
                };
                if (params.node.rowIndex === 0) {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "기준\n약정금",
              field: "SC6",
              width: 70,
              flex: 1,
              pinned: "left",
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#ffebe6",
                };
                if (params.node.rowIndex === 0) {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "당월\n약정금",
              field: "SC7",
              width: 70,
              flex: 1,
              pinned: "left",
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#ffcbff", // 연보라
                };
                if (params.node.rowIndex !== 0) {
                  if (
                    params.data &&
                    Math.round(params.data.SC7 / 10000) >
                      Math.round(params.data.SC6 / 10000)
                  ) {
                    style.color = "#FF0000";
                  } else if (
                    params.data.SC7 / 1000 <
                    params.data.SC6 / 1000
                  ) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#000000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "계약\n만료일",
              field: "SC8",
              width: 80,
              flex: 1,
              pinned: "left",
              cellStyle: (params) => {
                const style = {
                  justifyContent: "center",
                  backgroundColor: "#fff200",
                };
                if (params.node.rowIndex === 0) {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
          ],
        },
        {
          headerName: "인원관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            justifyContent: "center",
          },
          children: [
            {
              headerName: "기준TO",
              field: "SC9",
              minWidth: 60,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "당월TO",
              field: "SC10",
              minWidth: 60,
              flex: 1,
              // valueFormatter: (params) => {
              //   if (params.value == null || params.value === "") {
              //     return ""; // 값이 없으면 빈 문자열 반환
              //   }
              //   return Number(params.value).toLocaleString();
              // },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "PO",
              field: "SC11",
              minWidth: 60,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "수익관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            justifyContent: "center",
          },
          children: [
            {
              headerName: "적자",
              minWidth: 70,
              flex: 1,
              field: "SC12",
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "흑자",
              minWidth: 70,
              flex: 1,
              field: "SC13",
              // valueFormatter: (params) => {
              //   if (params.value == null || params.value === "") {
              //     return ""; // 값이 없으면 빈 문자열 반환
              //   }
              //   return Number(params.value).toLocaleString();
              // },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "전월\n누적",
              field: "SC14",
              minWidth: 70,
              flex: 1,
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                };
                if (params.node.rowIndex !== 0) {
                  if (params.data && params.data.SC14 < 0) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#FF0000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "당월\n수익",
              field: "SC15",
              minWidth: 70,
              flex: 1,
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                };
                if (params.node.rowIndex !== 0) {
                  if (params.data && params.data.SC14 < 0) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#FF0000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "수익\n합계",
              minWidth: 70,
              flex: 1,
              field: "SC16",
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                };
                if (params.node.rowIndex !== 0) {
                  if (
                    params.data &&
                    Number(params.data.SC13 || 0) +
                      Number(params.data.SC14 || 0) <
                      0
                  ) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#FF0000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
          ],
        },
        {
          headerName: "",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            justifyContent: "center",
          },
          children: [
            {
              headerName: "타입",
              field: "SC17",
              minWidth: 50,
              flex: 1,
              cellStyle: (params) => {
                const style = {
                  justifyContent: "center",
                  backgroundColor: "#bbddff",
                };
                if (params.node.rowIndex === 0) {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "평균\n점수",
              minWidth: 50,
              flex: 1,
              field: "SC18",
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#bbddff",
                };
                if (params.node.rowIndex === 0) {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
          ],
        },
        {
          headerName: "수량관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "당일",
              field: "SC19",
              minWidth: 60,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "당월",
              field: "SC20",
              minWidth: 70,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "예상수량",
              field: "SC21",
              minWidth: 70,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "최고수량",
              field: "SC22",
              minWidth: 70,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "수량차이",
              minWidth: 70,
              flex: 1,
              field: "SC23",
              cellStyle: (params) => {
                const style = { justifyContent: "right" };
                const goalQty = params.data.SC22;

                // goalQty가 유효한 값일 때만 스타일 계산
                if (params.node.rowIndex !== 0) {
                  if (goalQty !== "" && goalQty != null) {
                    const diff = Math.round(
                      (params.data.SC21 || 0) - (goalQty || 0)
                    );

                    // 글자색 설정
                    if (params.node.rowIndex !== 0) {
                      if (diff >= 0) {
                        style.color = "#FF0000"; // red
                      } else {
                        style.color = "#0000FF"; // blue
                      }

                      // 배경색 설정
                      if (diff <= 0 && diff >= -50) {
                        style.backgroundColor = "#00FF00"; // green
                      } else if (diff < -50 && diff >= -100) {
                        style.backgroundColor = "#f7ff4f"; // H4FFFF7 -> RGB(247, 255, 255)와 유사
                      } else if (diff <= -101) {
                        style.backgroundColor = "#FF0000"; // red
                      } else {
                        style.backgroundColor = "#FFFFFF"; // white
                      }
                    }
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "최고대비\n증감률",
              minWidth: 60,
              flex: 1,
              field: "SC24",
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "매출관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "총매출액",
              field: "SC25",
              minWidth: 70,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "현금매출",
              field: "SC26",
              minWidth: 60,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "달성점수",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "10이하",
              field: "SC27",
              minWidth: 60,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "20이하",
              field: "SC28",
              minWidth: 60,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "일계",
              field: "SC29",
              minWidth: 70,
              flex: 1,
              // valueFormatter: (params) => {
              //   if (params.value == null || params.value === "") {
              //     return ""; // 값이 없으면 빈 문자열 반환
              //   }
              //   return Number(params.value).toLocaleString();
              // },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "누계",
              field: "SC30",
              minWidth: 70,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "예상",
              minWidth: 70,
              flex: 1,
              field: "SC31",
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "고객분석",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "당 일",
              field: "SC32",
              minWidth: 60,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "당 월",
              field: "SC33",
              minWidth: 60,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "누 적",
              field: "SC34",
              minWidth: 70,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "개폐점관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "개점\n시간",
              field: "SC35",
              minWidth: 50,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "전일\n폐점",
              field: "SC36",
              minWidth: 50,
              flex: 1,
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
      ],

      storeCountGridOptions: {
        headerHeight: 35,
        rowHeight: 22,
        quickFilterText: "",
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: true,
          comparator: (valueA, valueB) => {
            const isANumber = !isNaN(parseFloat(valueA)) && isFinite(valueA);
            const isBNumber = !isNaN(parseFloat(valueB)) && isFinite(valueB);

            if (isANumber && isBNumber) {
              return valueA - valueB;
            }
            if (!isANumber && !isBNumber) {
              return String(valueA).localeCompare(String(valueB));
            }
            return isANumber ? -1 : 1;
          },
          resizable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a0caf3",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },
    };
  },
  computed: {
    isSaveButtonVisible() {
      // '관리자'가 아닐 경우에만 저장 버튼을 표시합니다.
      return (
        this.userInfo &&
        ["관리자", "장영환"].includes(
          this.userInfo.EMP_NM
        )
      );
    },

    monthlyProjectedValue() {
      const currentMonth = new Date().getMonth() + 1; // 현재 월 (1-12)
      const projectedRow = this.totalMonthlyCountData[3]; // 4번째 행 (월예상)
      return projectedRow ? projectedRow[`M${currentMonth}`] : null;
    },

    // 현재 월인지 확인
    isCurrentMonth() {
      const now = new Date();
      return this.selectedMonth === now.getMonth() + 1;
    },

    dailySalesCountColumnDefs() {
      return [
        {
          headerName: `${this.selectedMonth}월`, // 동적
          headerStyle: {
            color: "black",
            backgroundColor: "#c0ffc0",
            textAlign: "center",
          },
          children: [
            {
              headerName: "",
              field: "week",
              flex: 0.8,
              cellStyle: {
                justifyContent: "center",
                backgroundColor: "#c0ffc0",
              },
            },
            {
              headerName: "일",
              field: "sun",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "월",
              field: "mon",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "화",
              field: "tue",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "수",
              field: "wed",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "목",
              field: "thu",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "금",
              field: "fri",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "토",
              field: "sat",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
          ],
        },
      ];
    },

    dailyLastSalesCountColumnDefs() {
      return [
        {
          headerName: `전년 ${this.selectedMonth}월`, // 동적
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
          },
          children: [
            {
              headerName: "",
              field: "week",
              flex: 0.8,
              cellStyle: {
                justifyContent: "center",
                backgroundColor: "#a0caf3",
              },
            },

            {
              headerName: "일",
              field: "sun",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "월",
              field: "mon",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "화",
              field: "tue",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "수",
              field: "wed",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "목",
              field: "thu",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "금",
              field: "fri",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
            {
              headerName: "토",
              field: "sat",
              flex: 1,
              valueFormatter: (params) => Number(params.value),
              cellStyle: { justifyContent: "center" },
            },
          ],
        },
      ];
    },
  },
  methods: {
    refreshPage() {
      this.reloadData();
    },
    async reloadData() {
      this.isLoading = true;
      try {
        if (this.userInfo.OGN_FG === "01") {
          return;
        } else if (['김정규', '김종배', '이재진', '육상용', '장영환', '남상만', '김춘규'].includes(this.userInfo.EMP_NM)||
          ['관리자팀','판매전쟁실'].includes(this.userInfo.EMP_DEPT_NM)){
          await Promise.all([
            this.fetchMonthlySalesCount(),
            this.fetchDailySalesCount(),
            this.fetchDailyLastSalesCount(),
            this.fetchTotalSale(),
            this.fetchAvgCount(),
            this.fetchStoreCount(),
          ]);
        }
      } catch (error) {
        console.error("데이터 새로고침 중 오류 발생:", error);
      } finally {
        this.isLoading = false;
      }
    },
    formatNumber(value) {
      // 값이 있을 경우에만 처리
      if (value) {
        // 소숫점이 있는 경우 반올림
        const roundedValue = Math.round(Number(value));
        // 천단위 구분자 추가
        return roundedValue.toLocaleString();
      }
      return "";
    },
    async fetchMonthlySalesCount() {
      try {
        const response = await axios.get(
          "/api/gtListPage/fetchMonthlySalesCount"
        );
        

        this.totalMonthlyCountData = response.data;
      } catch (error) {
        console.error("fetchMonthlySalesCount 로딩 실패:", error);
      }
    },

    isToday(dateStr) {
      if (!dateStr) return false;
      const todayDate = new Date();
      const year = todayDate.getFullYear();
      const month = String(todayDate.getMonth() + 1).padStart(2, "0");
      const day = String(todayDate.getDate()).padStart(2, "0");
      const today = `${year}${month}${day}`;

      return dateStr === today;
    },

    processCalendarData(rawData) {
      const weeks = {};
      const dayMap = {
        "일": "sun",
        "월": "mon",
        "화": "tue",
        "수": "wed",
        "목": "thu",
        "금": "fri",
        "토": "sat"
      };

      // 1~6주 기본 구조 생성 (값은 0으로 초기화)
      for (let i = 1; i <= 6; i++) {
        weeks[i] = {
          week: `${i}주`,
          sun: 0, mon: 0, tue: 0, wed: 0,
          thu: 0, fri: 0, sat: 0
        };
      }

      // 실제 데이터 반영
      rawData.forEach(row => {
        const { WeekNo, DayOfWeek, Value } = row;
        const dayKey = dayMap[DayOfWeek];
        if (!dayKey) return;

        if (weeks[WeekNo]) {
          weeks[WeekNo][dayKey] = Value;
        }
      });

      return Object.values(weeks);

    },

    async fetchDailySalesCount() {
      try {
        const params = {};

        if (this.selectedMonth) {
          params.selectedMonth = this.selectedMonth;
        }
        const response = await axios.get(
          "/api/gtListPage/fetchDailySalesCount",
          { params }
        );
        this.dailySalesCountData = this.processCalendarData(response.data);
      } catch (error) {
        console.error("fetchDailySalesCount 로딩 실패:", error);
      }
    },

    async fetchDailyLastSalesCount() {
      try {
        const params = {};

        if (this.selectedMonth) {
          params.selectedMonth = this.selectedMonth;
        }
        const response = await axios.get(
          "/api/gtListPage/fetchDailyLastSalesCount",
          { params }
        );
        this.dailyLastSalesCountData = this.processCalendarData(response.data);
      } catch (error) {
        console.error("fetchDailyLastSalesCount 로딩 실패:", error);
      }
    },

    async fetchTotalSale() {
      try {
        const response = await axios.get("/api/gtListPage/fetchTotalSale");
        this.totalSaleData = response.data;
      } catch (error) {
        console.error("fetchTotalSale 로딩 실패:", error);
      }
    },

    async fetchAvgCount() {
      try {
        const response = await axios.get("/api/gtListPage/fetchAvgCount");
        let data = response.data;

        //  row 5개 더 추가
        for (let i = 0; i < 5; i++) {
          data.push({}); // 빈 행 추가 (필드값은 필요에 따라 기본값 세팅 가능)
        }

        this.avgCountData = data;

      } catch (error) {
        console.error("fetchAvgCount 로딩 실패:", error);
      }
    },

    async fetchStoreCount() {
      try {
        const response = await axios.get("/api/gtListPage/fetchStoreCount");
        let data = response.data;

        //  row 5개 더 추가
        for (let i = 0; i < 5; i++) {
          data.push({}); // 빈 행 추가 (필드값은 필요에 따라 기본값 세팅 가능)
        }
        
        this.storeCountData = data;
        
      } catch (error) {
        console.error("fetchAvgCount 로딩 실패:", error);
      }
    },

    avgCountCellStyle(params) {
      const style = { justifyContent: "center", };
      const field = params.colDef.field;

      // 상단 고정 행 스타일
      if (params.node.rowIndex === 0) {
        style.backgroundColor = "#fbaad0";
        style.justifyContent = "center";
        return style;
      }

      // "NO" 컬럼 스타일
      if (field === "RowNo") {
        // style.backgroundColor = "#dcb9ff";
        style.justifyContent = "center";
      } else if (field && field.endsWith("BN")) {
        // "본부" 컬럼들
        style.backgroundColor = "#ffffbb";
      } else {
        style.justifyContent = "right";
      }

      if (params.rowIndex === 4) {
        // 5번째 행
        // style.backgroundColor = "#00ff00";
      }

      return style;
    },

    avgCountcellClass(params) {
      if (params.rowIndex === 8) {
        return ["blinking-cell-yellow"];
      } else if (params.rowIndex === 9) {
        return ["blinking-cell-red"];
      }
    },

    storeCountCellStyle(params) {
      const style = {};
      const field = params.colDef.field;
      const centerAlignFields = [
        "SC1",
        "SC2",
        "SC3",
        "ZK_SURETY_ED",
        "TRBIZ_TYPE",
        "OPEN_HR",
        "CLOSE_HR",
      ];

      // 상단 고정 행 스타일
      if (params.node.rowIndex === 0) {
        style.backgroundColor = "#dedfde";
        style.borderColor = "#FF0000";
      }

      if (centerAlignFields.includes(field)) {
        style.justifyContent = "center";
      } else {
        style.justifyContent = "right";
      }

      return style;
    },
    onStoreCountDoubleClicked(params) {
      if (params.colDef.field === "SHOP_NM") {
        if (params.node.rowPinned) return;
        this.popupShopCd = params.data.SHOP_CD;
        this.popupShopNm = params.data.SHOP_NM;
        this.showPopup = true;
      }
    },
    closePopup() {
      this.showPopup = false;
    },

    async onStoreCountCellValueChanged(params) {
      
      const { colDef, data, newValue, oldValue } = params;

      if (newValue === oldValue) {
        return;
      }

      // SHOP_CD가 데이터에 없으면 업데이트 불가.
      if (!data.SHOP_CD) {
        console.error("SHOP_CD가 없어 업데이트할 수 없습니다.");
        alert("업데이트에 필요한 정보(SHOP_CD)가 없습니다.");
        data[colDef.field] = oldValue; // 데이터만 복구
        params.api.refreshCells({ rowNodes: [params.node] });
        return;
      }

      if (colDef.field === "LASTPROFIT") {
        try {
          await axios.post("/api/trListPage/saveLastProfit", {
            shopCd: data.SHOP_CD,
            newValue: newValue ?? 0,
            index: 0
          });
          this.calculateStoreCountAverages();
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }

      if (colDef.field === "PROFIT") {
        try {
          await axios.post("/api/trListPage/saveLastProfit", {
            shopCd: data.SHOP_CD,
            newValue: newValue ?? 0,
            index: 1
          });
          this.calculateStoreCountAverages();
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }

      if (colDef.field === "STAFF_CNT") {
        try {
          await axios.post("/api/trListPage/saveStaffCnt", {
            shopCd: data.SHOP_CD,
            userId: this.userInfo.userId,
            toCnt: data.TO_CNT || 0,
            workerCnt: data.STAFF_CNT || 0,
          });
          this.calculateStoreCountAverages();
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }

      if (["SHOP_MASTER_NM", "AGE", "CAREER"].includes(colDef.field)) {
        try {
          await axios.post("/api/trListPage/saveMasterInfo", {
            shopCd: data.SHOP_CD,
            shopMasterNm: data.SHOP_MASTER_NM, 
            age: data.AGE,
            career: data.CAREER,
          });
          this.calculateStoreCountAverages(); // 나이/경력 평균 재계산
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }
    },

    onTotalMonthlyCountGridReady(params) { this.totalMonthlyCountGridApi = params.api; },
    onAvgCountGridReady(params) { this.avgCountGridApi = params.api; },
    onDailyLastSalesCountGridReady(params) { this.dailyLastSalesCountGridApi = params.api; },
    onDailySalesCountGridReady(params) { this.dailySalesCountGridApi = params.api; },
    onGridReady(params) { this.gridApi = params.api; },


    totalMonthlyCountCopy() {
      this.copyData(this.totalMonthlyCountGridApi);
    },
    avgCountCopy() {
      this.copyData(this.avgCountGridApi);
    },
    dailyLastSalesCountCopy() {
      this.copyData(this.dailyLastSalesCountGridApi);
    },
    dailySalesCountCopy() {
      this.copyData(this.dailySalesCountGridApi);
    },
    storeCountCopy() {
      this.copyData(this.gridApi);
    },
    copyData(gridApi) {
      if (!gridApi) {
        alert("그리드 복사 기능을 사용할 수 없습니다. 데이터를 다시 불러온 후 다시 시도해주세요.");
        return;
      }
      const csvData = gridApi.getDataAsCsv({
        // 헤더 가공: \n 제거
        processHeaderCallback: (params) => {
          const def = params.column.getColDef();
          const header = def.headerName ?? def.field ?? "";
          return String(header).replace(/\r?\n/g, " "); // 줄바꿈 → 공백
        },
        // 셀 값 가공(필요하면): 셀 안의 줄바꿈도 제거
        processCellCallback: (params) => {
          const v = params.value;
          if (v == null) return "";
          return String(v).replace(/\r?\n/g, " ");
        },
        // 엑셀 친화 옵션
        columnSeparator: "\t", // 탭 구분 → 엑셀에 바로 셀 분리
        suppressQuotes: true, // 큰따옴표 억제(헤더에 따옴표 생기는 문제 방지)
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => alert("복사되었습니다."))
          .catch((err) => console.error("Clipboard copy failed: ", err));
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = csvData;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("복사되었습니다.");
      }
    },

    // 중첩된 컬럼 정의에서 실제 데이터가 들어가는 자식 컬럼들만 추출하는 헬퍼
    getLeafDefs(defs) {
      const leafCols = [];
      const traverse = (cols) => {
        cols.forEach((c) => {
          if (c.children) traverse(c.children);
          else leafCols.push(c);
        });
      };
      traverse(defs);
      return leafCols;
    },

    handlePaste(event) {
      const focusedElement = document.activeElement;
      const grids = [
        { selector: ".total-monthly-grid-ag", api: this.totalMonthlyCountGridApi, defs: this.totalMonthlyCountColumnDefs },
        { selector: ".avg-stats-grid-ag", api: this.avgCountGridApi, defs: this.avgCountColumnDefs },
        { selector: ".last-sales-calendar-ag", api: this.dailyLastSalesCountGridApi, defs: this.dailyLastSalesCountColumnDefs },
        { selector: ".sales-calendar-ag", api: this.dailySalesCountGridApi, defs: this.dailySalesCountColumnDefs },
        { selector: ".store-count-grid-ag", api: this.gridApi, defs: this.storeCountColumnDefs }
      ];

      const targetGrid = grids.find(g => document.querySelector(g.selector)?.contains(focusedElement));
      if (!targetGrid || !targetGrid.api) return;

      const clipboardData = event.clipboardData.getData("text");
      const rows = clipboardData.split(/\r\n|\n|\r/);
      const focusedCell = targetGrid.api.getFocusedCell();
      if (!focusedCell) return;

      const leafDefs = this.getLeafDefs(targetGrid.defs);
      const startRow = focusedCell.rowIndex;
      const startCol = leafDefs.findIndex(col => col.field === focusedCell.column.colId);

      // 필요한 행 수 계산 및 추가
      const requiredRows = startRow + rows.length;
      const currentRows = targetGrid.api.getDisplayedRowCount();
      if (requiredRows > currentRows) {
        const rowsToAdd = Array(requiredRows - currentRows).fill({});
        targetGrid.api.applyTransaction({ add: rowsToAdd });
      }

      // 데이터 붙여넣기
      rows.forEach((row, rowIndex) => {
        const cells = row.split("\t");
        const rowNode = targetGrid.api.getDisplayedRowAtIndex(startRow + rowIndex);
        if (!rowNode) return; // 안전하게
        cells.forEach((cell, colIndex) => {
          const colDef = leafDefs[startCol + colIndex];
          const colId = colDef?.field;
          if (colId) {
            let value = cell.trim();
            // valueFormatter가 있는 컬럼은 숫자로 변환 (숫자 컬럼으로 가정)
            if (colDef.valueFormatter || colDef.cellDataType === 'number') {
              value = value === "" ? null : Number(value);
            }
              
            rowNode.setDataValue(colId, value);
          }
        });
      });
      event.preventDefault();
    },

    async saveTotalMonthlyCount() {
      if (!confirm("데이터를 저장하시겠습니까?")) return;
      try {
        await axios.post("/api/gtListPage/saveTotalMonthlyCount", {
          
          gridData: this.totalMonthlyCountData,
          userId: this.userInfo?.USER_ID || "Unknown"
        });
        this.fetchMonthlySalesCount();
        alert("저장되었습니다.");
      } catch (error) {
        alert("저장 실패");
      }
    },

    async saveAvgCount() {
      if (!confirm("통계 테이블 데이터를 저장하시겠습니까?")) return;
      try {
        await axios.post("/api/gtListPage/saveAvgCount", {
          
          gridData: this.avgCountData,
          userId: this.userInfo?.USER_ID || "Unknown"
        });
        this.fetchAvgCount();
        alert("저장되었습니다.");
      } catch (error) {
        alert("저장 실패");
      }
    },

    async saveDailyLastSalesCount() {
      if (!confirm("통계 테이블 데이터를 저장하시겠습니까?")) return;
      try {
        await axios.post("/api/gtListPage/saveDailyLastSalesCount", {
          
          gridData: this.dailyLastSalesCountData,
          userId: this.userInfo?.USER_ID || "Unknown"
        });
        this.fetchDailyLastSalesCount();
        alert("저장되었습니다.");
      } catch (error) {
        alert("저장 실패");
      }
    },
    
    async saveDailySales() {
      if (!confirm("통계 테이블 데이터를 저장하시겠습니까?")) return;
      try {
        await axios.post("/api/gtListPage/saveDailySales", {
          
          gridData: this.dailySalesCountData,
          userId: this.userInfo?.USER_ID || "Unknown"
        });
        this.fetchDailySalesCount();
        alert("저장되었습니다.");
      } catch (error) {
        alert("저장 실패");
      }
    },

    async saveStatsTable() {
      if (!confirm("통계 테이블 데이터를 저장하시겠습니까?")) return;
      try {
        await axios.post("/api/gtListPage/saveStatsTable", {
          
          tableData: this.totalSaleData[0],
          userId: this.userInfo?.USER_ID || "Unknown"
        });
        await this.fetchTotalSale();
        alert("저장되었습니다.");
      } catch (error) {
        alert("저장 실패");
      }
    },

    async saveStoreCount() {
      if (!confirm("통계 테이블 데이터를 저장하시겠습니까?")) return;
      try {
        await axios.post("/api/gtListPage/saveStoreCount", {
          
          gridData: this.storeCountData,
          userId: this.userInfo?.USER_ID || "Unknown"
        });
        this.fetchStoreCount();
        alert("저장되었습니다.");
      } catch (error) {
        alert("저장 실패");
      }
    },
    
  },
  watch: {},
  mounted() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    const topTranData = {
      shopName: this.userInfo?.SHOP_NM || "본사로그인",
      telNo: this.userInfo?.TEL_NO,
    };

    this.$emit("top-info-change", topTranData);

    this.reloadData();
  document.addEventListener("paste", this.handlePaste);
  },
  beforeUnmount() {
    document.removeEventListener("paste", this.handlePaste);
  },
};
</script>

<style scoped>
.tr-list-page {
  padding: 2px;
  height: 99%;
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
}

.main-grid-layout {
  display: grid;
  grid-template-columns: 1.2fr 1.2fr 0.5fr 1fr; /* 4개의 동일한 너비의 컬럼 */
  grid-template-rows: 1fr 1fr 1.6fr;
  grid-template-areas:
    "sales-area sales-area sales-area monthly-stats-area"
    "middle-area middle-area middle-area monthly-stats-area"
    "bottom-area bottom-area bottom-area bottom-area";
  height: 100%;
}

.sales-grid {
  grid-area: sales-area;
}
.monthly-stats-grid {
  grid-area: monthly-stats-area;
}
.middle-container {
  grid-area: middle-area;
}

.bottom-grid {
  grid-area: bottom-area;
}

.middle-container {
  display: grid;
  grid-template-columns: 1fr 1fr 0.4fr;
  /* align-items: stretch; 내부 아이템들이 높이를 채우도록 함 */
}

.stats-table table {
  font-size: 0.75rem;
  border: 1px solid black;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
}

.stats-table th {
  border: 1px solid black;
  text-align: center;
  padding: 4px;
  background-color: #f0f0f0;
  font-weight: normal;
}

.stats-table td {
  border: 1px solid black;
  text-align: right;
  padding: 4px;
  background-color: #ffacd6;
}


.month-control {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 4px;
}

.month-btn {
  padding: 4px 8px;
  border: 1px solid #ccc;
  background-color: white;
  cursor: pointer;
  border-radius: 4px;
}

.month-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.month-display {
  font-size: 1rem;
  font-weight: bold;
  min-width: 120px;
  text-align: center;
}

.refresh-btn {
  margin-left: auto;
  padding: 8px 12px;
  border: 1px solid #ccc;
  background-color: #e0e0e0;
  cursor: pointer;
  border-radius: 4px;
  font-size: 0.9rem;
}

.refresh-btn:hover {
  background-color: #d0d0d0;
}

:deep(.ag-tr-balham) {
  font-family: "맑은 고딕", Malgun Gothic, sans-serif; /* VB 설정과 동일 */
  --ag-cell-horizontal-padding: 1.5px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

:deep(.ag-tr-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* grid 헤더 텍스트 정렬 */
:deep(.ag-tr-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  align-items: center !important;
  font-weight: normal;
  font-size: 0.7rem;
}

:deep(.ag-tr-balham .ag-cell) {
  font-size: 0.7rem;
  display: flex;
  align-items: center; /* 수직 중앙 정렬 textAlign 안먹고 justifyContent 적용 가운데로 잘 안와서*/
}

:deep(.middle-grid .ag-cell) {
  font-size: 0.75rem;
  display: flex;
  align-items: center; /* 수직 중앙 정렬 */
}

/* 각 그리드 컨테이너 공통 스타일 */
.sales-grid,
.group-grid,
.right-stats-grid,
.monthly-stats-grid,
.bottom-grid,
.stats-table {
  border: 1px solid #ccc;
  background: white;
  display: flex;
  flex-direction: column;
}

:deep(.blinking-cell-red) {
  animation: blink-effect-red 1s step-end infinite;
  animation-delay: 0s;
}

@keyframes blink-effect-red {
  0%,
  100% {
    background-color: #ff0000; /* 빨간색 */
  }
  50% {
    background-color: #ffffff; /* 하얀색 */
  }
}

:deep(.blinking-cell-yellow) {
  animation: blink-effect-yellow 1s step-end infinite;
  animation-delay: 0s;
}

@keyframes blink-effect-yellow {
  0%,
  100% {
    background-color: #fff000; /* 빨간색 */
  }
  50% {
    background-color: #ffffff; /* 하얀색 */
  }
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  .stats-table table {
    font-size: 1rem;
  }

  :deep(.ag-tr-balham .ag-cell) {
    font-size: 0.85rem;
  }
  :deep(.middle-grid .ag-cell) {
    font-size: 1rem;
  }
  :deep(.top-grid .ag-cell) {
    font-size: 1rem;
  }

  :deep(.ag-tr-balham .ag-header-cell-text) {
    font-size: 0.8rem;
  }
  :deep(.middle-grid .ag-header-cell-text, .top-grid .ag-header-cell-text) {
    font-size: 0.9rem;
  }
}
.ag-tr-balham {
  flex: 1;
  width: 100%;
}

.stats-table table {
  flex: 1;
}

.button-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  align-items: center;
}

.btn-save-grid {
  display: inline-flex;
  width: fit-content;
  padding: 2px 10px;
  margin: 2px;
  font-size: 0.75rem;
  cursor: pointer;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 3px;
}
</style>
